import React from "react"
import { useTranslation } from "react-i18next"

import { PrimaryButton,  SecondaryButton } from "../../../components/Common/Form/Button"

const FooterSticky = ({
    isBlocked,
    onhandleOrder,
    weight,
    total,
    title,
    checkOrderInFunction,
    fromOrderUpload,
    titleDelete,
    onhandleDelete,
    isBlockedPrimary 
}) => {
    const { t } = useTranslation()
    const loginDetails = sessionStorage.getItem("userDetails")
    const interUserFlag = loginDetails
        ? JSON.parse(loginDetails)?.user_details?.user_type
        : {}
    const functionDetailsLoggedInUser = loginDetails
        ? JSON.parse(loginDetails)?.user_details
        : {}
    let checkFunction = functionDetailsLoggedInUser?.service_center_details.filter((item) =>{ return item.function.includes("order")} )
    return (
        <div className="flex justify-between items-center sticky__footer sticky bottom-0 bg-white border-t px-10 border-lightGray pb-2 pt-3">
            <div className="text-xs text-secondary-50">

                <div className="gap-4 flex ">
                    <div className="flex gap-1">
                        <p>{ t("orderManagement.weight") }</p><p className="font-bold">{ weight }</p>
                    </div>
                    { interUserFlag == 1 && checkFunction.length > 0 && <div className="flex gap-1">
                        <p >{ t("orderManagement.total") }</p><p className="font-bold">{ total }</p>
                    </div> }
                    { interUserFlag == 2 && checkOrderInFunction && <div className="flex gap-1">
                        <p >{ t("orderManagement.total") }</p><p className="font-bold">{ total }</p>
                    </div> }
                </div>
            </div>

            <div className="button__group gap-4 flex ">
                { fromOrderUpload && <PrimaryButton handler={ onhandleDelete } title={ titleDelete } />}
                <SecondaryButton handler={ onhandleOrder } title={ title } disable={ isBlocked }/>
            </div>

        </div>
    )
}

export default FooterSticky
